import axios from "axios";
import { config } from "@num/config"

let fakedOrders = {

}
let possibleFakeStatus = ["new", "in_production", "done"]

let count = 0;

let mocks = {
  async "GET /api/order"() {
    let req = await axios.get(config.MOCK_ORDERS_FILE, {params: {rand: Math.random()}})

    if (count > 2) {
      req.data[0].status.code = 'in_box_1';
    }
    if (count > 4) {
      req.data[1].status.code = 'in_box_2';
    }
    if (count > 6) {
      req.data[4].status.code = 'in_box_3';
    }

    if (!config.FEATURE_ORDERBOXES) {
      if (count > 8) {
        req.data[5].status.code = 'in_box_1';
      }
      if (count > 10) {
        req.data[6].status.code = 'in_box_2';
      }
      if (count > 12) {
        req.data[7].status.code = 'in_box_3';
      }
      if (count > 14) {
        req.data[8].status.code = 'in_box_3';
      }
      if (count > 16) {
        req.data[9].status.code = 'in_box_3';
      }
      if (count > 18) {
        req.data[10].status.code = 'in_box_3';
      }
    }
    
    count++;
    

    // if (req.data) {
    //   let i = 0
    //   while (req.data.length < 30) {
    //     i++
    //     let cln = JSON.parse(JSON.stringify(req.data[0]))
    //     cln.id = 100 + i
    //     cln.number =  (cln.id/1000).toFixed(3).substr(-3)
    //     cln.status.code = possibleFakeStatus[i % possibleFakeStatus.length]
    //     req.data.push(cln)
    //   }
    // }
    req.data.forEach(v => v.status.code = fakedOrders[v.id] || v.status.code)
    return req
  },
  "PATCH /api/order"(method, url, order) {
    fakedOrders[order.id] = order.status
    return fakeRequest({}, true, 200)
  }
}

export function ajaxmock(method, url, ...args) {
  let path = url
  let fncPath = method.toUpperCase() + " " + path
  
  let fnc = null
  if (fncPath in mocks) {
    fnc = fncPath
  } else if (path in mocks) {
    fnc = path
  } else {
    Object.keys(mocks)
      .forEach(v => {
        if (fncPath.indexOf(v) == 0) {
          fnc = v
        }
      })
  }

  if (fnc) {
    return mocks[fnc](method, url, ...args)
      .then((res) => {
        console.debug("mock:", fnc, args, res)
        return Promise.resolve(res)
      })
      .catch((res) => {
        console.debug("mock:", fnc, args, res, "failed")
        return Promise.reject(res)
      })
  }

  return Promise.reject('mock not found: ' + fncPath)
}

function fakeRequest(data, success = true, timeout = 0) {
  return new Promise((resolve, reject) => {
    setTimeout(success ? resolve : reject, timeout, {
      data: {
        status: success,
        response: data,
      },
      statusCode: success ? 200 : 500,
      status: success ? 200 : 500,  //TODO: there is a difference in the APIs on response formatting
    })
  })
}
